<template>
    <div class="editor">
        <div id="sidebar-controls">
            <button id="image-button" @click.prevent="openModal('editor-image-media-library', 'image')"><i class="icon ion-md-image"></i></button>
            <button id="attach-button" @click.prevent="openModal('editor-image-media-library', 'file')"><i class="icon ion-md-attach"></i></button>
            <button id="video-button" v-on:click.stop.prevent="openModal('new-video')"><i class="icon ion-logo-youtube"></i></button>
        </div>

        <div id="content-editor"></div>

        <button class="btn btn-small add-comment" v-if="comment" v-on:click.stop.prevent="fireCommentEvent">Reply</button>

        <div class="modal micromodal-slide" id="new-video" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-new-category-title">
                    <div class="modal__content" id="modal-new-category-content">
                        <h3>Insert YouTube or Vimeo video</h3>
                        <div class="form__group flex">
                            <input type="text" id="youtube_url" name="youtube_url" class="form__control" placeholder="Enter the video url" v-model="youtube_url">
                        </div>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-primary" v-on:click.stop.prevent="addVideo">Insert YouTube video</button>
                    </footer>
                </div>
            </div>
        </div>

        <media-library
            name="editor-image-media-library"
            :opened="modalOpened"
            @closedModal="onClosedModal"
            :group="group"
            :type="fileType"
            v-model="files" />
    </div>
</template>

<script>
    // Todo: This could be prettier 😕  ...

    import Quill from 'quill';
    import 'quill-mention';
    import MicroModal from 'micromodal';
    
    let Inline = Quill.import('blots/inline');
    let Block = Quill.import('blots/block');
    let BlockEmbed = Quill.import('blots/block/embed');

    class ImageBlot extends BlockEmbed {
        static create(value) {
            let node = super.create();
            node.setAttribute('alt', value.alt);
            node.setAttribute('src', value.url);
            return node;
        }

        static value(node) {
            return {
                alt: node.getAttribute('alt'),
                url: node.getAttribute('src')
            };
        }
    }

    ImageBlot.blotName = 'image';
    ImageBlot.tagName = 'img';

    class VideoBlot extends BlockEmbed {
      static create(url) {
        let node = super.create();
        node.setAttribute('src', url);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', true);
        node.setAttribute('height', '400');
        node.setAttribute('width', '100%');
        node.contentEditable = 'false';
        //this._addRemovalButton(node);

        node.innerHTML = '<div><iframe src="'+url+'" frameborder="0" allowfullscreen="true" height="400" width="100%"></iframe></div>';
        return node;
      }

      // static _addRemovalButton(node) {
      //   const button = document.createElement('button');
      //   button.innerText = 'x';
      //   button.onclick = () => node.remove();
      //   button.contentEditable = 'false';
      //   node.appendChild(button);

      //   // Extra span forces the cursor to the end of
      //   // the label, otherwise it appears inside the
      //   // removal button
      //   const span = document.createElement('span');
      //   span.innerText = ' ';
      //   node.appendChild(span);
      // }

      // static formats(node) {
      //   // We still need to report unregistered embed formats
      //   let format = {};
      //   if (node.hasAttribute('height')) {
      //     format.height = node.getAttribute('height');
      //   }
      //   if (node.hasAttribute('width')) {
      //     format.width = node.getAttribute('width');
      //   }
      //   return format;
      // }

      static value(node) {
        return node.getAttribute('src');
      }

      // format(name, value) {
      //   // Handle unregistered embed formats
      //   if (name === 'height' || name === 'width') {
      //     if (value) {
      //       this.domNode.setAttribute(name, value);
      //     } else {
      //       this.domNode.removeAttribute(name, value);
      //     }
      //   } else {
      //       super.format(name, value);
      //   }
      // }
    }
    VideoBlot.blotName = 'video';
    VideoBlot.tagName = 'div';

    class FileBlot extends BlockEmbed {

        static create(value) {
            const fileIcons = {
                'application/pdf' : '/images/file-icons/pdf.svg',
                'application/zip' : '/images/file-icons/zip.svg',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : '/images/file-icons/xlsx.svg'
            };

            var image = '/images/file-icons/default.svg';

            if( value.thumbnail != "" ){
                image = value.thumbnail;
            }else{
                if( value.icon != "" ){
                    image = value.icon;
                }else{
                    if( typeof fileIcons[value.type] != 'undefined'){
                        image = fileIcons[value.type];
                    }
                }

            }

            let node = super.create();
            node.setAttribute('contenteditable', "false");
            node.setAttribute('target', "_blank");
            //node.setAttribute('href', value.url);

            node.innerHTML = '<div><img class="file__icon rounded" width="40" height="40" src="' + image + '"></div><div class="file__info"><span class="file__name">' + value.name + '</span><br><span class="file__size">'+ value.size +'</span></div><a href="'+ value.url +'?download=true&as=' + value.name +'" class="file__download btn btn-small"><i class="icon ion-md-download"></i></a>';
            return node;
        }

        static value(node) {
            return {
                size: node.getAttribute('data-size'),
                type: node.getAttribute('data-type'),
                url: node.getAttribute('data-url')
            };
        }
    }

    FileBlot.blotName = 'file';
    FileBlot.className = 'ql-file-attachment-block';
    FileBlot.tagName = 'div';

    export default {
        props: {
            comment: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: 'What would you like to share?',
            },
            value: {
                default: "",
            },
            group : {
                type: Object
            }
        },
        data(){
            return {
                editor: null,
                content: '',
                youtube_url: null,
                files: [],
                modalOpened: false,
                fileType: 'image',
            }
        },
        computed: {
            youTubeEmbedURL(){
                return '//www.youtube.com/embed/' + this.getYouTubeId(this.youtube_url) + '?showinfo=0&modestbranding=1';
            },
            vimeoEmbedURL(){
                return '//player.vimeo.com/video/' + this.getVimeoId(this.youtube_url) + '';
            }
        },
        mounted(){
            this.setUpEditor();
        },
        watch: {
            content(content) {
                this.$emit('input', content);
            },
            files(files) {
                console.log(files);
                let token = document.head.querySelector('meta[name="csrf-token"]');
                if(typeof files !== 'undefined' && typeof files[0] !== 'undefined' && token){
                    let range = this.editor.getSelection(true);

                    if(this.fileType === 'image') {
                        this.editor.insertEmbed(range.index, this.fileType, {
                            url: files[0].url ?? files[0].urls.raw + "&q=80&w=1080"
                        }, Quill.sources.USER);
                    } else {
                        this.editor.insertEmbed(
                            range.index,
                            this.fileType,
                            files[0],
                            Quill.sources.USER
                        );
                    }

                    this.editor.setSelection(range.index + 1, Quill.sources.SILENT);

                    console.log(files[0]);
                }
            },
            value() {
                if(this.content === "" || this.value === ""){
                    this.editor.root.innerHTML = this.value;
                }
            }
        },
        methods: {
            onClosedModal(){
                this.modalOpened = false;
                this.closeModal('editor-image-media-library')
            },
            openModal(modal, fileType = 'image'){
                if(modal==="editor-image-media-library"){
                    this.modalOpened = true;
                }
                this.fileType = fileType;
                MicroModal.show(modal);
            },
            closeModal(modal){
                MicroModal.close(modal)
            },
            getYouTubeId(url) {
                const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                const match = url.match(regExp);

                return (match && match[2].length === 11)
                  ? match[2]
                  : null;
            },
            getVimeoId(url) {
                const regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
                const match = url.match(regExp);

                return match[1];
            },
            fireCommentEvent(event) {
                this.$emit('add-comment', this.editor);
            },
            update(){
                this.content = this.editor.root.innerHTML;
            },
            setUpEditor(){
                Quill.debug(false);
                Quill.register(ImageBlot);
                Quill.register(VideoBlot);
                Quill.register(FileBlot);
                
                var Delta = Quill.import('delta');

                this.editor = new Quill('#content-editor', {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'link', {'list': 'bullet'}, {'list': 'ordered'}, {'list': 'check'}]
                        ],
                        mention: {
                            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                            mentionDenotationChars: ["@"],
                            source: function (searchTerm, renderList, mentionChar) {
                                let values;

                                if (searchTerm.length === 0) {
                                    renderList(values, searchTerm);
                                } else {
                                    axios.get('/api/account/users/search?q=' + searchTerm).then((response) => {
                                        renderList(response.data, searchTerm);
                                    }, (response) => {
                                        this.error = response;
                                    });
                                }
                            },
                        },
                    },
                    theme: 'bubble',
                    formats: ['bold', 'underline', 'header', 'italic', 'link', 'image', 'video', 'file', 'list', 'mention'],
                    placeholder: this.placeholder
                });

                let sidebarControls = document.querySelector('#sidebar-controls');

                this.editor.addContainer( sidebarControls );

                this.editor.on(Quill.events.EDITOR_CHANGE, (eventType, range) => {
                    let sidebarControls = document.querySelector('#sidebar-controls');

                    if (eventType !== Quill.events.SELECTION_CHANGE) return;
                    
                    if (range == null) return;

                    if (range.length === 0) {

                        let [block, offset] = this.editor.scroll.descendant(Block, range.index);

                        if (block != null && block.domNode.firstChild instanceof HTMLBRElement) {
                            let lineBounds = this.editor.getBounds(range);
                            sidebarControls.classList.remove("active");
                            sidebarControls.style.display = 'block';
                            sidebarControls.style.right = (lineBounds.right) + 'px';
                            sidebarControls.style.top = (lineBounds.top - 8) + 'px';
                        } else {
                            sidebarControls.style.display = 'none';
                            sidebarControls.classList.remove("active");
                        }

                    } else {
                        sidebarControls.style.display = 'none';
                        sidebarControls.classList.remove("active");

                        let rangeBounds = this.editor.getBounds(range);
                    }
                });

                this.editor.root.innerHTML = this.content;
                this.editor.on('text-change', () => this.update());

                var change = new Delta();
                this.editor.on('text-change', function(delta) {
                    change = change.compose(delta);
                });

                // Save periodically
                setInterval(() => {
                    if (change.length() > 0) {
                        this.$emit('update', this.editor.getContents());

                        change = new Delta();
                    }
                }, 5*1000);

                // Check for unsaved data
                window.onbeforeunload = function() {
                    if (change.length() > 0) {
                        return 'There are unsaved changes. Are you sure you want to leave?';
                    }
                }
            },
            addVideo(){
                if(this.youtube_url){
                    let range = this.editor.getSelection(true);
                    let url = "";
                    
                    if(this.youtube_url.includes("youtube.com") || this.youtube_url.includes("youtu.be")){
                        url = this.youTubeEmbedURL;
                    }else{
                        url = this.vimeoEmbedURL;
                    }
                    
                    let status = this.editor.insertEmbed(range.index+1, 'video', url, Quill.sources.USER);
                    
                    this.editor.formatText(range.index + 1, 1, { height: '450', width: '100%' });
                    this.editor.setSelection(range.index + 2, Quill.sources.SILENT);

                    this.hideSidebarControls();
                    this.youtube_url = null;
                    MicroModal.close('new-video');
                }

            }, 
            addImage(){
                //console.log('addImage');

                let range = this.editor.getSelection(true);

                // let status = this.editor.insertEmbed(range.index, 'image', {
                //     alt: 'Quill Cloud',
                //     url: 'https://www.class-creative.com/wp-content/uploads/2018/04/Class-Creative-Team-Shot.jpg'
                // }, Quill.sources.USER);

                // this.editor.setSelection(range.index + 1, Quill.sources.SILENT);
                
                this.hideSidebarControls();
            },
            hideSidebarControls(){
                let sidebarControls = document.querySelector('#sidebar-controls');
                sidebarControls.style.display = 'none';
            }
        }
    }
</script>

<style lang="scss">
    .editor{
        position: relative;
        min-height: 90px;

        .add-comment{
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
    }
</style>